import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { BatchFetchStockRequest, SkuStockLevels } from '../types/stock';

export interface StockApiContract {
  batchFetchStock(body: BatchFetchStockRequest): Promise<SkuStockLevels[]>;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    stock: StockApiContract;
  }
}

/**
 * A service to interact with stock levels via the SparkLayer API.
 */
export class StockApi extends ApiService implements StockApiContract {
  public batchFetchStock(body: BatchFetchStockRequest): Promise<SkuStockLevels[]> {
    return this.api.proxy({
      method: 'POST',
      path: '/v1/batch-fetch-stock',
      payload: body,
    });
  }
}
